import { forwardRef, Switch, SwitchProps, useMultiStyleConfig } from '@chakra-ui/react';
import Skeleton from '../Skeleton/Skeleton';
import SkeletonBox from '../Skeleton/SkeletonBox';
import Badge from '../Badge/Badge';

export interface ToggleComponentProps extends SwitchProps {
  size?: 'md' | 'sm';
  isLoading?: boolean;
}
const ToggleComponent = forwardRef<ToggleComponentProps, 'input'>((props, ref) => {
  const { isLoading, isReadOnly, isChecked, ...rest } = props;
  const { skeleton } = useMultiStyleConfig('Switch', props);
  if (isLoading) {
    return (
      <Skeleton isActive>
        <SkeletonBox __css={skeleton} />
      </Skeleton>
    );
  }
  if (isReadOnly) {
    if (isChecked)
      return (
        <Badge
          userSelect="none"
          cursor="default"
          w="40"
          variant="subtle"
          colorScheme="positive"
          justifyContent="center"
        >
          ON
        </Badge>
      );
    return (
      <Badge userSelect="none" cursor="default" w="40" justifyContent="center">
        OFF
      </Badge>
    );
  }
  return <Switch ref={ref} isReadOnly={isReadOnly} isChecked={isChecked} {...rest} />;
});

export default ToggleComponent;
